import axios from 'axios';

/**
 * Threads that do NOT live in the tenant `comments` collection, keyed by
 * `onModel`. Each entry maps the four thread operations to that resource's own
 * endpoints, so the shared <Comments> panel works against them unchanged.
 *
 * `wishlist` — Organization Wishlist threads, stored in the master DB and
 * shared with TherapyLake admins (api/src/wishlist).
 */
const remoteThreads = {
    wishlist: {
        list: (resourceId, params) => axios.get(`/wishlist/${resourceId}/comments`, { auth: true, params: { ...params } }),
        create: ({ onModel, resourceId, ...body }) => axios.post(`/wishlist/${resourceId}/comments`, body, { auth: true }),
        edit: (id, body) => axios.patch(`/wishlist/comments/${id}`, body, { auth: true }),
        remove: (id) => axios.delete(`/wishlist/comments/${id}`, { auth: true }),
    },
};

export const commentService = {
    getCommentsService: (onModel, resourceId, params) =>
        remoteThreads[onModel]
            ? remoteThreads[onModel].list(resourceId, params)
            : axios.get(`/comment/${onModel}/${resourceId}`, { auth: true, params: { ...params } }),

    createCommentService: (body) =>
        remoteThreads[body?.onModel] ? remoteThreads[body.onModel].create(body) : axios.post(`/comment`, body, { auth: true }),

    editCommentService: (id, body, onModel) =>
        remoteThreads[onModel] ? remoteThreads[onModel].edit(id, body) : axios.patch(`/comment/${id}`, body, { auth: true }),

    deleteCommentService: (id, onModel) =>
        remoteThreads[onModel] ? remoteThreads[onModel].remove(id) : axios.delete(`/comment/${id}`, { auth: true }),

    // Paginated staff search for the @mention autocomplete. Uses the same
    // searchValue/searchKey + skip/limit contract as GET /staff/basic/info
    // (the backend ignores a bare `search` param — see SelectAutocompletePagination).
    getMentionStaffService: ({ search, skip, limit }) =>
        axios.get(`/staff/basic/info`, {
            auth: true,
            params: {
                skip,
                limit,
                searchValue: search || undefined,
                searchKey: search ? 'NAME' : undefined,
                sortType: 'fullName',
                orderType: 'ASC',
            },
        }),
};
